import user from '@/endpoints/flexigo-users';
import Repository from './repository';

const client = new Repository();

export default {
  async getLocations(accountId, locationType = 'FLEXIRIDE_REQUEST') {
    const response = await client.get(`${user.locations}/${accountId}`, { locationType });
    return response;
  },

  async saveLocation(accountId, locationType, payload) {
    const p = { ...payload, accountId, locationType };
    const response = await client.post(user.locations, p);
    return response;
  },

  async updateLocation(id, locationType, payload) {
    const response = await client.put(`${user.locations}/${id}`, payload);
    return response;
  },
  async deleteLocation(id) {
    const response = await client.delete(`${user.locations}/${id}`);
    return response;
  },
  async getNotes(accountId, noteType = 'FLEXIRIDE_REQUEST') {
    const response = await client.get(`${user.notes}/${accountId}`, { noteType });
    return response;
  },

  async saveNote(accountId, note, noteType) {
    const response = await client.post(user.notes, { accountId, note, noteType });
    return response;
  },

  async deleteNote(noteId) {
    const response = await client.delete(`${user.notes}/${noteId}`);
    return response;
  },

  async updateNote(noteId, note, noteType) {
    const response = await client.put(`${user.notes}/${noteId}`, { note, noteType });
    return response;
  },

  async getOrganizationLocations(locationType = 'FLEXIRIDE_REQUEST', organizationId = undefined) {
    let response = '';
    if (organizationId) {
      response = await client.get(`${user.organizationLocations}?locationType=${locationType}&organizationId=${organizationId}`);
    } else {
      response = await client.get(`${user.organizationLocations}`, { locationType });
    }
    return response;
  },

  async saveOrganizationLocations(payload, locationType = 'FLEXIRIDE_REQUEST') {
    const response = await client.post(`${user.organizationLocations}?locationType=${locationType}`, payload);
    return response;
  },

  async savePreferences(key, value) {
    const url = `${user.preferences}/${key}`;
    const localClient = new Repository({ headers: { 'Content-Type': 'text/plain' } });
    // console.log(value);
    // console.log(JSON.stringify(value));
    const response = await localClient.post(url, JSON.stringify(value));
    return response;
  },

  async getPreferences(key) {
    const url = `${user.preferences}/${key}`;
    const response = await client.get(url);
    return response;
  },

};
